import Vue from 'vue'
import App from './App.vue'
import store from '../store'
import router from './router'

Vue.prototype.$liff = window.liff
Vue.prototype.$fna = window.fna
import Meta from "vue-meta";
Vue.use(Meta);

import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import VueLocalForage from "vue-localforage";
Vue.use(VueLocalForage);

import Vuex from 'vuex'
Vue.use(Vuex)

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
